import Tracker from './tracker';

interface ITrackerProps {
  value: string;
  label: string;
}

class FeedbackTracker extends Tracker {
  /** 数据上报 */
  X5tracing = ({ label, value }: ITrackerProps) => {
    try {
      this.commonTracker({
        category: `x5_userguide_email`,
        action: 'click_feedback',
        label,
        value,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export default new FeedbackTracker();
